import React, { useState, Fragment } from "react";
import Input from "../../components/input";
import { useParams } from "react-router-dom";
import {useResetPasswordMutation} from "../../services/accountsApi";

import CircularProgress from '@material-ui/core/CircularProgress';
import warningIcon from "../../img/warning-icon.svg"
import Login from "../login";

const ResetPassword = ({ show, handleClose, handleShow }) => {
  const [initResetPassword, {isLoading: resetPasswordIsLoading}] = useResetPasswordMutation();

  const [loader, setLoader] = useState(false)
  const [success, setSuccess] = useState(false)
  const [password, setPassword] = useState({
    value: "",
    error: null,
  });
  const [confirmPassword, setConfirmPassword] = useState({
    value: "",
    error: null,
  });
  let { token } = useParams();
  const submit = (e) => {
    e.preventDefault();
    setLoader(true)
    console.log({
      token,
      password: password.value,
      confirmPassword: confirmPassword.value,
    });
    initResetPassword({
      token,
      password: password.value,
      confirmPassword: confirmPassword.value,
    })
    .unwrap()
    .then(r => {
      setLoader(false)
      setSuccess(true)
    }).catch(e => {
      setLoader(false)
      console.log(e)
    });

  };
  return (

    <Fragment>
        <Login handleClose={handleClose} show={show} handleShow={handleShow} />
        <div className="row-modal-2" style={{ justifyContent:'center' }}>
          <div className="reset-password-card">
            {success ?
              <Fragment>
                <img src={warningIcon} alt="warning icon" height="46px" width="46px" style={{ margin: "0 0 2em 0" }} />
                <p>Your password has been changed</p>
              </Fragment>
              :
              <Fragment>
                <h3 className="fadeIn first title">Reset Password</h3>
                <form onSubmit={submit} className="formLogin d-block" style={{margin:'0'}}>
                  <Input
                    label="New password"
                    state={password}
                    setState={setPassword}
                    name={password}
                    type="password"
                    className="w-100"
                    signup={true}
                  />
                  <div className={`message-error `} role="alert" style={{margin: '1em 0 0 0'}}>
                    &#8226; The password must not contain the login of the account
                    or its screen name.
                    <br />
                    &#8226; Passwords must be at least 8 characters long.
                    <br />
                    &#8226; The password must contain at least one
                    uppercase,lowercase, digits and symbols.
                    <br />
                  </div>
                  <Input
                    label="Confirm Password"
                    state={confirmPassword}
                    setState={setConfirmPassword}
                    name={confirmPassword}
                    type="password"
                    signup={true}
                  />

                  <div className="boxInput" style={{margin:'0', alignItems: 'center', width:'100%' }}>

                    {!loader ? <button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      className="orange-button orange-hover"
                      style={{ width:'100%', margin:'0' }}
                    >
                      Save New Password
                    </button>
                      :
                      <CircularProgress style={{ color: "#F29B1B" }} />
                    }
                  </div>
                </form>
              </Fragment>
            }

          </div>
        </div>      

    </Fragment>
  );
};

export default ResetPassword;
